import React from 'react';
import PropTypes from 'prop-types';

export default function Section({ data }) {
    const { title, description, photo, type = "image", textPosition, overlayBackground } = data;

    return (
        <>
            <section className="tf-section three_step p-4">
                <div className="overlay" style={{ background: overlayBackground }} />
                <div className="container">
                    <div className="row">
                        {textPosition === 'left' && (
                            <div className="col-md-6 d-flex flex-column justify-content-center">
                                <div className="tf-title mb-4 left" data-aos="fade-up" data-aos-duration={800}>
                                    <h2 className="title">{title}</h2>
                                </div>
                                <div className="wrap-box" data-aos="fade-up" data-aos-duration={800}>
                                    {Array.isArray(description) ? (
                                        <>
                                            <ul style={{ marginLeft: '20px', paddingLeft: '20px' }}>
                                                {description.slice(0, -1).map((desc, index) => (
                                                    <li key={index} style={{ listStyleType: 'disc' }}>{desc}</li>
                                                ))}
                                            </ul>
                                            <p>{description[description.length - 1]}</p>
                                        </>
                                    ) : (
                                        <p>{description}</p>
                                    )}
                                </div>
                            </div>
                        )}
                        <div className="col-md-6 d-flex justify-content-center align-items-center">
                            {type === "video" ? (
                                photo.includes("youtube.com") ? (
                                    <div className="image ratio ratio-16x9 rounded-3 overflow-hidden w-100">
                                        <iframe
                                            src={photo.replace("watch?v=", "embed/")}
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                            className="w-100 h-100 rounded-video"
                                        ></iframe>
                                    </div>
                                ) : (
                                    <video src={photo} className="rounded-video" controls style={{ width: '100%', height: 'auto' }} />
                                )
                            ) : (
                                <img src={photo} className="rounded-video move5" alt="" style={{ width: 'auto', height: '300px' }} />
                            )}
                        </div>
                        {textPosition === 'right' && (
                            <div className="col-md-6 d-flex flex-column justify-content-center">
                                <div className="tf-title mb-4 left" data-aos="fade-up" data-aos-duration={800}>
                                    <h2 className="title">{title}</h2>
                                </div>
                                <div className="wrap-box" data-aos="fade-up" data-aos-duration={800}>
                                    {Array.isArray(description) ? (
                                        <>
                                            <ul style={{ marginLeft: '20px', paddingLeft: '20px' }}>
                                                {description.slice(0, -1).map((desc, index) => (
                                                    <li key={index} style={{ listStyleType: 'disc' }}>{desc}</li>
                                                ))}
                                            </ul>
                                            <p className="mt-3">{description[description.length - 1]}</p>
                                        </>
                                    ) : (
                                        <p>{description}</p>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
            <style jsx>{`
                .rounded-video {
                    border-radius: 15px;
                }
            `}</style>
        </>
    );
}

Section.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string)
        ]).isRequired,
        photo: PropTypes.string.isRequired,
        type: PropTypes.string,
        textPosition: PropTypes.string,
        overlayBackground: PropTypes.string
    }).isRequired
};